var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
define(["require", "exports", "hypo_bvo/Drklein/Shared/AgentService", "hypo_bvo/Drklein/ProfilKontaktformular/ProfilKontaktformular.constants", "hypo_bvo/Drklein/ProfilKontaktformular/ProfilKontaktformular.service", "jquery"], function (require, exports, AgentService, ProfilKontaktformular_constants_1, ProfilKontaktformularService) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.showKontaktformular = void 0;
    AgentService = __importStar(AgentService);
    ProfilKontaktformularService = __importStar(ProfilKontaktformularService);
    var $formularContainer;
    var $kontaktformularHint;
    var $tabContent;
    var $kontaktformularSelectField;
    var tabContentSelector = ".profilKontaktformular";
    var dropdownId = "#kontaktformularChoice_profil-information";
    function createFormularLink(productGroup, label) {
        return "<a data-produktsparte='".concat(productGroup.platformId, "' href='").concat(dropdownId, "'>").concat(label, "</a>");
    }
    function createBeratungsleistungSpecificHintText(productGroups) {
        if (productGroups.length === 0) {
            return "";
        }
        var antragsformularText = productGroups.length === 1
            ? "dem ausführlichen Antragsformular"
            : "den ausführlichen Antragsformularen";
        var explanationTextStart = "Falls Sie bereits ein konkretes Projekt im Auge haben, k\u00F6nnen Sie mit ".concat(antragsformularText, " direkt ");
        var explanationTextEnd = " anfordern und damit verlässlich weiterplanen.";
        var beratungsleistungenText = concatenateTexts(productGroups.map(function (productGroup) {
            return createFormularLink(productGroup, ProfilKontaktformular_constants_1.constants.produktspartenLabels[productGroup.platformId].beratungsleistung);
        }));
        return explanationTextStart + beratungsleistungenText + explanationTextEnd;
    }
    function concatenateTexts(textArray) {
        var arrayLength = textArray.length;
        if (arrayLength === 1) {
            return textArray[0];
        }
        var result = textArray[0];
        for (var i = 1; i < arrayLength - 1; i++) {
            result += ", ".concat(textArray[i]);
        }
        return "".concat(result, " oder ").concat(textArray[arrayLength - 1]);
    }
    function addKontaktformularHint(productGroups) {
        var $beratungsleistungSpecificHintText = $("<p />").html(createBeratungsleistungSpecificHintText(productGroups));
        $beratungsleistungSpecificHintText.appendTo($kontaktformularHint);
        $kontaktformularHint.show();
    }
    function addOnClickEventToHintLinks(productGroups) {
        productGroups.forEach(function (productGroup) {
            $kontaktformularHint
                .find("a[data-produktsparte=".concat(productGroup.platformId, "]"))
                .on("click", function () {
                showKontaktformular(productGroup.platformId);
            });
        });
    }
    function addProduktteaserToSelectField(productGroups) {
        productGroups.forEach(function (productGroup) {
            $kontaktformularSelectField.append($("<option />", {
                value: productGroup.platformId,
                text: ProfilKontaktformular_constants_1.constants.produktspartenLabels[productGroup.platformId].teaser,
            }));
        });
    }
    function getKontaktformularElement(produktsparte) {
        if (produktsparte === "None") {
            return $("".concat(tabContentSelector, "_formularSimple"));
        }
        return $("".concat(tabContentSelector, "_formular").concat(produktsparte));
    }
    function loadAntragForProduktsparte(produktsparte, $targetElement, agentId) {
        if (ProfilKontaktformular_constants_1.constants.produktspartenLabels.hasOwnProperty(produktsparte) && ProfilKontaktformular_constants_1.constants.produktspartenLabels[produktsparte].hasOwnProperty("formiName")) {
            ProfilKontaktformularService.provideFormiAntrag(produktsparte, $targetElement, agentId);
        }
        else {
            var formularMapping = {
                "VERSICHERUNG": "/_assets/hypo-elements/JavaScript/Partials/Versicherungsantrag/Versicherungsantrag.js",
                "GELDANLAGE": "/_assets/hypo-elements/JavaScript/Templates/KurzFormular/Fondsantrag.js",
                "BAUFINANZIERUNG": "/_assets/hypo-elements/JavaScript/Templates/KurzFormular/Bausparantrag.js",
                "Simple": "/_assets/hypo-bvo/JavaScript/Bvo/Drklein/BeraterKontaktformular/BeraterKontaktformular.js",
            };
            if (formularMapping.hasOwnProperty(produktsparte)) {
                require([formularMapping[produktsparte]]);
            }
        }
    }
    function showKontaktformularInternally(produktsparte, agentId) {
        $formularContainer.children().hide();
        var $targetElement = getKontaktformularElement(produktsparte);
        loadAntragForProduktsparte(produktsparte, $targetElement, agentId);
        initializeOverlay(produktsparte);
        $targetElement.show();
    }
    function addOnChangeListenerToSelectField(agentId) {
        $kontaktformularSelectField.on("change", function () {
            var selectedProduktsparte = $kontaktformularSelectField.val();
            showKontaktformularInternally(selectedProduktsparte, agentId);
        });
    }
    function initializeOverlay(produktsparte) {
        var overlay = $(".profilKontaktformular_overlay");
        produktsparte === "None" ? $(overlay).show() : $(overlay).hide();
    }
    function showKontaktformular(productGroupPlatformId) {
        $kontaktformularSelectField.val(productGroupPlatformId);
        $kontaktformularSelectField.trigger("change");
    }
    exports.showKontaktformular = showKontaktformular;
    AgentService.getAgent($(".profilInformation").data("uid")).done(function (agent) {
        if (agent.employeeTags.includes("show_application_form")) {
            $(function () {
                $formularContainer = $(tabContentSelector + "_formularContainer");
                $kontaktformularHint = $(tabContentSelector + "_kontaktformularHint");
                $tabContent = $(tabContentSelector);
                $kontaktformularSelectField = $tabContent.find("select[name='kontaktformularChoice']");
                addKontaktformularHint(agent.productGroups);
                addProduktteaserToSelectField(agent.productGroups);
                addOnClickEventToHintLinks(agent.productGroups);
                addOnClickEventToHintLinks([
                    { platformId: "Simple", name: "Einfaches Kontaktformular" },
                    { platformId: "None", name: "Bitte auswählen" }
                ]);
                addOnChangeListenerToSelectField(agent.id);
            });
        }
    });
});
